import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../types'
import { HandBookFirstLevelData } from '../handbook-first-level/handbook-first-level.component.converter'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HandBookSecondLevelConverter extends CmsConverterService<HandBookSecondLevelData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      content: formData.st_content ?? defaultFSCatalog,
      headline: formData.st_headline ?? defaultTextInput
    }
  }
}

export const HANDBOOK_SECOND_LEVEL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HandBookSecondLevelData>>('HandBookSecondLevelConverter')

export interface HandBookSecondLevelData extends HandBookFirstLevelData, ConvertedComponentData {
}
